import React from 'react';
import styled from 'styled-components';
import { STRINGS } from 'config';
import { Div } from 'styles/elements/div';
import redCross from './redcross-small.png';
import doubleRedCross from './doubleredcross-small.png';
import redFlag from './redflag-small.png';
import blackFlag from './black-flag.png';
import mentalHealth from './mentalhealth.png';

const Icon = styled.img`
  height: 24px;
`;

const SmallIcon = styled.img`
  height: 16px;
`;

const SmallIconWrapper = styled(Div)`
  background: white;
  height: 18px;
  width: 24px;
  align-items: center;
  justify-content: center;
  margin: 0 1px;
  box-shadow: 2px 2px 3px -2px rgba(0,0,0,0.75);
`;

export const RedCross = () => <img src={redCross} alt="red cross" />;

export const DoubleRedCross = () => <img src={doubleRedCross} alt="double red cross" />;

export const RedFlag = () => <img src={redFlag} alt="red flag" />;

export const BlackFlag = () => <Icon src={blackFlag} alt="black flag" />;

export const MentalHealth = () => <SmallIconWrapper><SmallIcon src={mentalHealth} alt="mental health icon" /></SmallIconWrapper>;

const { TRIAGE_LEVEL, TAGS } = STRINGS;

export const ClinicalReviewIcon = ({ triageLevel }) => {
  switch (triageLevel) {
    case (TRIAGE_LEVEL.URGENT):
      return <RedCross />;
    case (TRIAGE_LEVEL.ADVICE_URGENT):
      return <RedCross />;
    case (TRIAGE_LEVEL.ADVICE_URGENT_MH):
      return <MentalHealth />;
    case (TRIAGE_LEVEL.RED_FLAG):
      return <RedFlag />;
    case (TRIAGE_LEVEL.EMERGENCY):
      return <DoubleRedCross />;
    case (TRIAGE_LEVEL.ADVICE_EMERGENCY):
      return <DoubleRedCross />;
    case (TRIAGE_LEVEL.ADVICE_EMERGENCY_MH):
      return <><MentalHealth /><MentalHealth /></>;
    case (TRIAGE_LEVEL.SUICIDAL):
      return <BlackFlag />;
    default:
      return null;
  }
};

export const Cigarette = styled.div`
  margin: 0 10px;
  height: 20px;
  :after {
    content: '\\1F6AC';
    font-size: 30px;
    line-height: 0.5;
  }
`;

export const Dice = styled.div`
  margin: 0 10px;
  height: 20px;
  position: relative;
  :after {
    content: '\\1F3B2';
    font-size: 30px;
    line-height: 0.5;
    position: absolute;
    top: 8px;
  }
`;

export const TaggedIcon = ({ tag }) => {
  switch (tag) {
    case (TAGS.ANSWER.SMOKER):
      return <Cigarette />;
    case (TAGS.ANSWER.GAMBLER):
      return <Dice />;
    default:
      return null;
  }
};
